import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import {
  InternalApiEntityGroup,
  InternalApiListSelectorGroup,
  InternalApiScreeningFlow,
  InternalApiScreeningMatchType,
} from '../../../api-internal';
import { faEquals, faMinus, faPlus, faTilde, faUnion } from '@fortawesome/pro-solid-svg-icons';
import { fa00 } from '@fortawesome/pro-duotone-svg-icons';
import { capitalize } from 'lodash';
import { SalvDataTag } from '@salvapp/ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTurnDownRight } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { ManualCustomListSelectorCode, selectorConfigByType } from '../lists/ListGroups';

export function getSreenedFieldsOptions(flows: InternalApiScreeningFlow[]): DropdownOption[] {
  return [...new Set(flows.map((flow) => flow.field))].map((fieldName) => toDropdownOption(fieldName)!);
}

export function getSegmentsOptions(segments: InternalApiEntityGroup[]): DropdownOption[] {
  return segments.map((segment) => toDropdownOption(segment.name, segment.code)!);
}

export function getSreenedAgainstOptions(flows: InternalApiScreeningFlow[]): DropdownOption[] {
  return [...new Set(flows.flatMap((flow) => flow.lists?.map(({ list }) => list.name)))].map((fieldName) =>
    toDropdownOption(fieldName)!
  );
}

export function toDropdownOption(value?: string, key?: string): DropdownOption | undefined {
  if (!value) {
    return;
  }
  return {
    key: key || value,
    value: value,
    label: value,
  };
}

export const getMatchIcon = (type: InternalApiScreeningMatchType) => {
  switch (type) {
    case InternalApiScreeningMatchType.EXACT_MATCH:
      return faEquals;
    case InternalApiScreeningMatchType.FUZZY_MATCH:
    case InternalApiScreeningMatchType.FUZZY_CONTAINS:
      return faTilde;
    case InternalApiScreeningMatchType.CONTAINS:
      return faUnion;
    case InternalApiScreeningMatchType.STARTS_WITH:
      return fa00;
  }
};

export const getMatchLabel = (type: InternalApiScreeningMatchType) => {
  switch (type) {
    case InternalApiScreeningMatchType.FUZZY_MATCH:
      return 'Fuzzy';
    case InternalApiScreeningMatchType.EXACT_MATCH:
      return 'Exact';
    case InternalApiScreeningMatchType.STARTS_WITH:
      return 'Prefix';
    case InternalApiScreeningMatchType.CONTAINS:
      return 'Contains';
    case InternalApiScreeningMatchType.FUZZY_CONTAINS:
      return 'Fuzzy contains';
    default:
      return capitalize(type);
  }
};

export const getSegmentIcon = (type: 'included' | 'excluded') => {
  switch (type) {
    case 'included':
      return faPlus;
    case 'excluded':
      return faMinus;
  }
};

export const ObjectSchemaFieldDataTag = (props: { value: string }) => {
  const [parentField, childField] = props.value.split('.');

  return (
    <SalvDataTag
      className={'object-schema-field-data-tag'}
      value={
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <span>{parentField}</span>
          <span style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faArrowTurnDownRight} />
            <span>{childField}</span>
          </span>
        </div>
      }
    />
  );
};

export const getScreeningFlowDisplayId = (flowId: string): string => {
  return flowId.substring(0, 18);
};

export const getListGroupLabel = (selectorGroup: InternalApiListSelectorGroup) => {
  return `${selectorConfigByType[selectorGroup.selectorCode as ManualCustomListSelectorCode].name} / ${selectorGroup?.name}`;
};
